import { render } from "./KioskLayout.vue?vue&type=template&id=85baad84&scoped=true"
import script from "./KioskLayout.vue?vue&type=script&lang=js"
export * from "./KioskLayout.vue?vue&type=script&lang=js"

import "./KioskLayout.vue?vue&type=style&index=0&id=85baad84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85baad84"]])

export default __exports__